import CsrFilter from '../components/CsrFilter'
import CsrSortablePublicationJobsList from '../react/CsrSortablePublicationJobsList'

export default class PubRevisionsReviews {
  constructor(params) {
    this.params = params;
    this.role = params.role || null
  }

  index() {
    this.csrFilter = new CsrFilter({selector: "#filter-csr-rep"});
    this.initializeListViews();
  }

  initializeListViews() {
    let keys;
    let klass;
    switch (this.role) {
      case "csr":
        keys = ["in_csr_revisions", "csr_revisions"]
        klass = CsrSortablePublicationJobsList
        return this.sortPubs(keys, klass)
        break;
    }
  }

  sortPubs(keys, klass){
    keys.forEach((ele) => {
      if ($(`.js-${ele}-pubs-react-data`).length) {
        let data = $(`.js-${ele}-pubs-react-data`).data("jobs");
        let list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-${ele}-pubs-table`,
          data: data,
          roleType: this.role
        });
        this.csrFilter.addList(ele, data, list);
        list.render()
      }
    });
  }
}
